<template>
    <section class="py-2 br-bottom br-top">
        <div class="container">
            <div class="row align-items-center justify-content-end">    
                <div class="col-xl-9 col-lg-8 col-md-7 col-sm-12">
                    <div class="filter_wraps elspo_wrap d-flex align-items-center justify-content-end">
                        <div class="single_fitres me-2 br-right">
                            <select @change="onSortChange" class="custom-select simple">
                                <option value="default" selected>Sorter tilfældigt</option>
                                <option value="price-asc">Sorter efter pris: Lav til høj</option>
                                <option value="price-desc">Sorter efter pris: Høj til lav</option>
                                <option value="new">Sorter efter nyeste</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { defineEmits } from 'vue';
const emit = defineEmits(['sort-change']);

const onSortChange = (event) => {
  emit('sort-change', event.target.value);
};
</script>